import React, { useState, useEffect } from "react";
import "./TurboGame.css";

const ROWS = 20;   // smaller for demo
const COLS = 20;

const TurboGame = () => {
  const [monsters, setMonsters] = useState([]);
  const [revealed, setRevealed] = useState(new Set());
  const [player, setPlayer] = useState({ row: 0, col: 0 });
  const [visited, setVisited] = useState(new Set());
  const [message, setMessage] = useState("");
  const [trials, setTrials] = useState(0);

  // Function to initialize the game
  const initGame = () => {
    const colsUsed = new Set();
    const newMonsters = [];
    for (let r = 1; r < ROWS - 1; r++) {
      let c;
      do {
        c = Math.floor(Math.random() * COLS);
      } while (colsUsed.has(c));
      colsUsed.add(c);
      newMonsters.push(`${r},${c}`);
    }
    setMonsters(newMonsters);
    setRevealed(new Set());
    setPlayer({ row: 0, col: Math.floor(Math.random() * COLS) });
    setVisited(new Set([`0,${player.col}`]));
    setMessage("Game started! 🐌");
    setTrials(0);
  };

  useEffect(() => {
    initGame();
  }, []);

  const movePlayer = (dr, dc) => {
    const newRow = player.row + dr;
    const newCol = player.col + dc;

    if (newRow < 0 || newRow >= ROWS || newCol < 0 || newCol >= COLS) return;

    const newPos = `${newRow},${newCol}`;

    if (monsters.includes(newPos)) {
      setMessage("💀 You hit a monster! Restarting trial...");
      setRevealed((prev) => new Set(prev).add(newPos));
      setPlayer({ row: 0, col: Math.floor(Math.random() * COLS) });
      setTrials((t) => t + 1);
      return;
    }

    setPlayer({ row: newRow, col: newCol });
    setVisited((prev) => new Set(prev).add(newPos));

    if (newRow === ROWS - 1) {
      setMessage("🎉 You reached the last row! You win!");
      setTrials((t) => t + 1);
    }
  };

  return (
    <div className="turbo-container">
      <h2>🐌 Turbo the Snail</h2>
      
     

      <div className="board">
        {Array.from({ length: ROWS }).map((_, r) => (
          <div key={r} className="row">
            {Array.from({ length: COLS }).map((_, c) => {
              const pos = `${r},${c}`;
              const isPlayer = player.row === r && player.col === c;
              const isVisited = visited.has(pos);
              const isMonster = revealed.has(pos);

              return (
                <div
                  key={c}
                  className={`cell ${isPlayer ? "player" : ""} ${
                    isVisited ? "visited" : ""
                  }`}
                >
                  {isPlayer ? "🐌" : isMonster ? "👾" : ""}
                </div>
              );
            })}
          </div>
        ))}
      </div>

      <div className="controls-container">
        <p><strong>Trials:</strong> {trials}</p>
        <p>{message}</p>
        <hr />
        <div className="controls">
<button onClick={() => movePlayer(0, -1)}>⬅️</button>
        <button onClick={() => movePlayer(-1, 0)}>⬆️</button>
          
          <button onClick={() => movePlayer(0, 1)}>➡️</button>
        
        <button onClick={() => movePlayer(1, 0)}>⬇️</button>
        </div>
        
      </div>

      <button className="restart-btn" onClick={initGame}>🔄 Restart</button>
    </div>
  );
};

export default TurboGame;
